import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { clientSettings } from 'go-modules/models/common/client.settings';
import type { AutoGradedRubricGenerationState } from '@go-modules/interfaces/rubrics/rubric';

@Injectable({
	providedIn: 'root'
})
export class RubricService {
	constructor (private http: HttpClient) {}

	public saveRubricSessionView (rubricSessionId: number, sessionId: number): Observable<void> {
		return this.http.post<void>(`${clientSettings.GoReactV2API}/submissions/${sessionId}/rubrics/${rubricSessionId}/view`, null);
	}

	public getAutoGradedRubricGenerationState (sessionId: number): Observable<AutoGradedRubricGenerationState> {
		return this.http.get<AutoGradedRubricGenerationState>(
			`${clientSettings.GoReactV2API}/submissions/${sessionId}/rubrics/auto-graded-generation`
		);
	}

	public retryAutoGradedRubricGeneration (sessionId: number): Observable<AutoGradedRubricGenerationState> {
		return this.http.post<AutoGradedRubricGenerationState>(
			`${clientSettings.GoReactV2API}/submissions/${sessionId}/rubrics/auto-graded-generation/retry`,
			null
		);
	}

}
